import React from"react";

const Dialog = ({ isOpen, onClose, children }) => {
if (!isOpen) return null;

return (
<div className="fixed inset-0 z-50 flex items-center justify-center bg-bgMain/40">
<div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md relative">
<button onClick={onClose} className="absolute top-2 right-2 text-gray-500 hover:text-red-500 text-xl" >
×
</button>
{children}
</div>
</div>
);
};

const DialogContent = ({ children }) => {
return <div className="mt-2">{children}</div>;
};

const DialogHeader = ({ children }) => {
return <div className="mb-3 text-lg font-semibold">{children}</div>;
};

const DialogTitle = ({ children }) => {
return <h2 className="text-xl font-bold text-gray-900">{children}</h2>;
};

export { Dialog, DialogContent, DialogHeader, DialogTitle };



